// Wrapper mínimo sobre localStorage para flags booleanos (p.ej. el estado
// expandido/colapsado de una sección). Falla en silencio si localStorage está
// deshabilitado (modo privado, sandbox de tests): devuelve el fallback en
// lectura y no-op en escritura. Mantiene la misma semántica que tenía
// CollapsibleSection inline, ahora reutilizable por los dueños del estado.
export function readBoolFlag(key, fallback = true) {
    try {
        const saved = localStorage.getItem(key);
        return saved === null ? fallback : saved === "true";
    } catch (e) {
        return fallback;
    }
}

export function writeBoolFlag(key, value) {
    try {
        localStorage.setItem(key, String(value));
    } catch (e) {
        /* noop — localStorage no disponible */
    }
}

// Variantes string para valores no booleanos (p.ej. la empresa activa
// seleccionada en el sidebar). Misma semántica fail-silent.
export function readStringFlag(key, fallback = null) {
    try {
        const saved = localStorage.getItem(key);
        return saved === null ? fallback : saved;
    } catch (e) {
        return fallback;
    }
}

export function writeStringFlag(key, value) {
    try {
        localStorage.setItem(key, String(value));
    } catch (e) {
        /* noop — localStorage no disponible */
    }
}

export function removeFlag(key) {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        /* noop — localStorage no disponible */
    }
}
